;(function () {
  'use strict'
  angular.module('contrast.ip').constant('IP_EXPIRATION_OPTIONS', [
    {
      value: 1,
      label: '30 minutes',
      translationId: 'detail_datePeriodThirtyMinutes'
    },
    { value: 2, label: '1 day', translationId: 'detail_datePeriodOneDay' },
    { value: 3, label: '1 week', translationId: 'detail_datePeriodOneWeek' },
    { value: 4, label: 'Never', translationId: 'detail_never' },
    { value: 5, label: 'Custom', translationId: 'detail_datePeriodCustom' }
  ])
})()
